<script>
import PaymentPlane from "../../../views/payment/payment-component.vue"
import appConfig from "@/app.config";
import Layout from "../../../layouts/main";

export default {
    components:{PaymentPlane, Layout},
  page: {
    title: "Paiement Success",
    meta: [{ name: "description", content: appConfig.description }]
  },

  data() {
    return{
      message: "Félicitations, votre paiement a été effectué avec succès. Merci pour votre confiance !",

    }
  },
}

 
</script>



<template>
    <Layout>
        <PaymentPlane :message="message" :isSuccess="true"> </PaymentPlane>
    </Layout>
</template> 